import React, { useReducer } from 'react';
import { BreadCrumb, FooterSection } from '../components';
import './../../styles/irctcForgotPasswordPage.css';
import './../../styles/UpdateCenterCommon.css';
import SimilarQuestions from '../components/SimilarQuestions';
import IrctcFaq from '../components/IrctcFaq';
import IrctcForgotUserNameForm from './components/IrctcForgotUserNameForm';
import IrctcUserNameSent from './components/IrctcUserNameSent';
import { FirstBookingPersuation } from '../components/FirstBookingPersuation';
import {
  FOOTER_DATA_IRCTC,
  IRCTC_BREAD_CRUMB_COMMON,
  IRCTC_EXTERNAL_JS,
  IRCTC_FAQ_TITLE,
  IRCTC_FORGOT_USERNAME_COMPONENTS,
  SIMILAR_QUESTIONS_TITLE
} from '../../utils/RailsSEOConstants';
import { irctcForgotUsernameInitialState, irctcForgotUsernameReducer } from '../../reducers/irctcForgotUsernameReducer';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';
import HtmlHeader from '../components/HtmlHeader';
import AdWrapper from '../components/AdWrapper';
import { AD_PAGES } from '../../utils/adsUtils';
import PropTypes from 'prop-types';
import { searchWidgetInitialState, searchWidgetReducer } from '../../reducers/searchWidgetReducer';
import SearchWidget from '../components/SearchWidget/SearchWidget';
import { TrainClasses } from '../route_info/TrainClasses';

const SearchWidgetContext = React.createContext<any>(searchWidgetInitialState);
export const IrctcForgotUsernameContext = React.createContext<any>(irctcForgotUsernameInitialState);

const IrctcForgotUserNamePage = (props) => {
  const { data } = props;
  const [searchWidgetState, searchWidgetDispatch] = useReducer(searchWidgetReducer, searchWidgetInitialState);
  const [state, dispatch] = useReducer(irctcForgotUsernameReducer, irctcForgotUsernameInitialState);
  const { componentToShow } = state;
  const {
    template: { h1_title: IRCTC_FORGOT_USERNAME_TITLE }
  } = data;
  return (
    <IrctcForgotUsernameContext.Provider value={{ forgotUserNameState: state, forgotUserNameDispatch: dispatch }}>
      <HtmlHeader data={data} />
      <SearchWidgetContext.Provider value={{ searchWidgetState, searchWidgetDispatch }}>
        <SearchWidget
          openDatePickerOnMount={false}
          topFix={true}
          classNode={TrainClasses.FC}
          pageWiseContext={SearchWidgetContext}
        />
      </SearchWidgetContext.Provider>
      <main className="container irctcLogin">
        <div className={`append_bottom30 appendTop30`}>
          <AdWrapper adsPageName={AD_PAGES.IRCTC_FORGOT_USERNAME_PAGE.adsPageName} />
        </div>
        <div className="appendBottom20">
          <BreadCrumb breadcrumb={data.template.breadcrumb} noLeftPadding />
        </div>
        <h1 className={'appendBottom15 font24'}>{IRCTC_FORGOT_USERNAME_TITLE}</h1>
        {componentToShow === IRCTC_FORGOT_USERNAME_COMPONENTS.inputForm && (
          <IrctcForgotUserNameForm customClass="appendBottom40" />
        )}
        {componentToShow === IRCTC_FORGOT_USERNAME_COMPONENTS.successPage && (
          <IrctcUserNameSent customClass="appendBottom40" />
        )}
        <FirstBookingPersuation />
        <h2>{SIMILAR_QUESTIONS_TITLE}</h2>
        <SimilarQuestions customClass="appendBottom40" />
        <h2>{IRCTC_FAQ_TITLE}</h2>
        <IrctcFaq customClass="appendBottom40" />
      </main>
      <FooterSection template={data.template} />
    </IrctcForgotUsernameContext.Provider>
  );
};

IrctcForgotUserNamePage.propTypes = {
  data: PropTypes.object
};
IrctcForgotUserNamePage.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: `irctc-forgot-username`,
    meta_title: `IRCTC Forgot User ID - How to Recover Your IRCTC User Name for IRCTC Login`,
    meta_description: `Need to reset your IRCTC User ID ? Follow the simple step-by-step guide on how to recover IRCTC User ID.`,
    meta_keywords: `IRCTC Forgot User ID, Recover IRCTC username,irctc login, irctc login id`,
    analytics: getStaticPageLoadEvent('seo:rails:irctcrecoverusername'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `IRCTC Forgot User ID`,
    breadcrumb: [
      ...IRCTC_BREAD_CRUMB_COMMON,
      {
        displayString: `IRCTC Forgot Username`,
        redirectionUrl: `https://www.makemytrip.com/railways/irctc-forgot-username.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/irctc-forgot-username.html`,
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };

  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_IRCTC-FORGOT-USERNAME.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default IrctcForgotUserNamePage;
